import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet,
} from '../../../../middleware/api';
import {
  GET_VOLCANO_LOCATIONS_FAILURE,
  GET_VOLCANO_LOCATIONS_REQUEST,
  GET_VOLCANO_LOCATIONS_SUCCESS,
  VOLCANO_LOCATION_SEARCH_COUNTRY_FAILURE,
  VOLCANO_LOCATION_SEARCH_COUNTRY_REQUEST,
  VOLCANO_LOCATION_SEARCH_COUNTRY_SUCCESS,
  VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_FAILURE,
  VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_REQUEST,
  VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_SUCCESS,
  VOLCANO_LOCATION_SEARCH_MORPHOLOGY_FAILURE,
  VOLCANO_LOCATION_SEARCH_MORPHOLOGY_REQUEST,
  VOLCANO_LOCATION_SEARCH_MORPHOLOGY_SUCCESS,
  VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_FAILURE,
  VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_REQUEST,
  VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_SUCCESS,
  VOLCANO_LOCATION_SEARCH_REGION_FAILURE,
  VOLCANO_LOCATION_SEARCH_REGION_REQUEST,
  VOLCANO_LOCATION_SEARCH_REGION_SUCCESS,
  VOLCANO_LOCATION_SEARCH_STATUS_FAILURE,
  VOLCANO_LOCATION_SEARCH_STATUS_REQUEST,
  VOLCANO_LOCATION_SEARCH_STATUS_SUCCESS,
} from './volcanoLocationSearchReducer';


const getVolcanoLocationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/volcanolocs', ...action }),
  requestType: GET_VOLCANO_LOCATIONS_REQUEST,
  successType: GET_VOLCANO_LOCATIONS_SUCCESS,
  failureType: GET_VOLCANO_LOCATIONS_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: VOLCANO_LOCATION_SEARCH_REGION_REQUEST,
  successType: VOLCANO_LOCATION_SEARCH_REGION_SUCCESS,
  failureType: VOLCANO_LOCATION_SEARCH_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/countries', ...action }),
  requestType: VOLCANO_LOCATION_SEARCH_COUNTRY_REQUEST,
  successType: VOLCANO_LOCATION_SEARCH_COUNTRY_SUCCESS,
  failureType: VOLCANO_LOCATION_SEARCH_COUNTRY_FAILURE,
});

const getStatusesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/statuses', ...action }),
  requestType: VOLCANO_LOCATION_SEARCH_STATUS_REQUEST,
  successType: VOLCANO_LOCATION_SEARCH_STATUS_SUCCESS,
  failureType: VOLCANO_LOCATION_SEARCH_STATUS_FAILURE,
});

const getVolcanoNamesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/names', ...action }),
  requestType: VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_REQUEST,
  successType: VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_SUCCESS,
  failureType: VOLCANO_LOCATION_SEARCH_VOLCANO_NAME_FAILURE,
});

const getMorphologiesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/morphologies', ...action }),
  requestType: VOLCANO_LOCATION_SEARCH_MORPHOLOGY_REQUEST,
  successType: VOLCANO_LOCATION_SEARCH_MORPHOLOGY_SUCCESS,
  failureType: VOLCANO_LOCATION_SEARCH_MORPHOLOGY_FAILURE,
});

const getEruptionTimesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/eruption-times', ...action }),
  requestType: VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_REQUEST,
  successType: VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_SUCCESS,
  failureType: VOLCANO_LOCATION_SEARCH_ERUPTION_TIME_FAILURE,
});

export const volcanoLocationSearchSagas = [
  getVolcanoLocationsSaga,
  getRegionsSaga,
  getCountriesSaga,
  getStatusesSaga,
  getVolcanoNamesSaga,
  getMorphologiesSaga,
  getEruptionTimesSaga,
];
